export const ArrowLeftPagination = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="8" viewBox="0 0 4 8" fill="none">
      <path d="M3.3335 0.666586L3.3335 7.33325L0.000162893 3.99992L3.3335 0.666586Z" fill="currentColor" />
    </svg>
  )
}
